module.exports = " <div class=waterfall> <div class=show-photo> <div class=d-photo v-for=\"img in imgs\"> <img v-bind:src=img.src> <a v-link=\"{ name: this.$route.name + 'Detail', params: {id: img.id }}\">{{img.title}}</a> </div> </div> <div class=show-more> <a><i class=\"fa fa-spinner\" aria-hidden=true></i>加载中..</a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/Waterfall.vue
 ** module id = 76
 ** module chunks = 0
 **/